import idx from "idx";
import { setCookie } from "../../../../util/auth";
import {
    getProjectSummary,
    saveProjectType
} from "../../../../actions/project-management.action";
import {
    addProjectAction,
} from "../../../../slice/project-summary";


/**
 * Updates basic project metadata and project action state in Redux store.
 *
 * @param {Object} params - Parameters object
 * @param {string} params.projectId - Unique project identifier
 * @param {Function} params.dispatch - Redux dispatch function
 * @param {string|null} [params.type=null] - Optional project type
 * @returns {Promise<void>}
 */
export const updateProject = async ({ projectId, dispatch, type = null }) => {
    if (!projectId) return;
    let totalApprovedInvoices = 0;
    let showStageSelect = false;

    dispatch(getProjectSummary(projectId)).then((projectData) => {
        // Save the project type to Redux and cookies
        if (projectData.projectType) {
            dispatch(saveProjectType(projectData.projectType));
            setCookie({ name: "projectType", value: projectData.projectType });
        }

        dispatch(addProjectAction({
            projectId: projectData.id,
            projectName: projectData.name,
            projectManagerName: idx(projectData, _ => _.manager.name),
            quoteType: projectData.quoteType,
            projectDescription: projectData.description,
            customerName: projectData.customer && projectData.customer.businessName,
            hasStages: projectData.hasStages,
            projectType: projectData.type,
            projectDataType: projectData.projectType,
            level: projectData.level,
            customerLevel: projectData.customer ? projectData.customer.level : "",
            contactData: projectData.customerContact,
            projectMarginValue: projectData.profitMarginValue || "",
            status: projectData.status,
            siteAddress: projectData.address,
            projectDueDate: projectData.dateOfCreation,
            attachmentArr: projectData.attachment,
            showStageSelect,
            totalApprovedInvoices,
            res: projectData
        }));
    });
};